import React from "react";

import LetterDialog, { LetterDialogActions, letterModalBodyClass } from "../UX/LetterDialog";

function ScheduledSendingModal({ open = true, onClose }) {
  return (
    <LetterDialog
      open={open}
      onClose={onClose}
      centered
      animationVariant="scaleFadeClimax"
      title={
        <>
          L&apos;envoi est{" "}
          <span className="italic text-modalPlum">programmé</span>
        </>
      }
      footer={
        <LetterDialogActions
          primaryLabel="D'accord"
          onPrimary={onClose}
          primaryVariant="green"
        />
      }
    >
      <p className={`${letterModalBodyClass} text-center`}>
        Un exemplaire de cette lettre sera remise en main propre à ce
        destinataire après ton décès, sans aucune action supplémentaire de ta
        part. Tu peux aussi l&apos;envoyer immédiatement de ton vivant via
        «&nbsp;Envoyer maintenant&nbsp;». Tu peux continuer à la modifier à tout
        moment. Retrouve ta lettre dans la section <em>Programmées</em>.
      </p>
    </LetterDialog>
  );
}

export default ScheduledSendingModal;
